import { useQuery } from '@tanstack/react-query'
import { getRequirementsByFuzzySearch } from 'api/requirements/getRequirementsByFuzzySearch'
import { requirementKeys } from './keys'

type UseFuzzySearchRequirementsQueryData = Awaited<
  ReturnType<typeof getRequirementsByFuzzySearch>
>

export const useFuzzySearchRequirementsQuery = ({ search, limit = 100 }) => {
  const trimmedSearch = search.trim()

  return useQuery<UseFuzzySearchRequirementsQueryData>({
    queryKey: requirementKeys.fuzzySearch({
      search: trimmedSearch,
      limit,
    }),
    queryFn: () =>
      getRequirementsByFuzzySearch({ search: trimmedSearch, limit }),
    enabled: trimmedSearch.length > 0,
  })
}
